import React from 'react'
import classnames from 'classnames'

import './DataTable.scss'

const DataTableHeader = ({ className, children }) => {
  return (
    <div className={classnames('datatable__header', className)}>{children}</div>
  )
}

export default DataTableHeader
